import { Routes, Route, Navigate } from 'react-router-dom';
import { AssetsDashboard } from './AssetsDashboard';
import { AssetRegistry } from './assets/AssetRegistry';
import { ITSMAssetDetailView } from './assets/AssetDetailView';
import { AddAssetView } from './assets/AddAssetView';
import { AssetRequestsView } from './requests/AssetRequestsView';
import { AssetAssignmentView } from './assign/AssetAssignmentView';
import { ReturnAssetView } from './return/ReturnAssetView';
import { StockManagementView } from './stock/StockManagementView';
import { ServiceScheduleView } from './service/ServiceScheduleView';
import { WarrantyTrackerView } from './warranty/WarrantyTrackerView';
import { PurchaseOrdersView } from './po/PurchaseOrdersView';
import { AssetVendors } from './vendors/AssetVendors';
import { AssetCategories } from './categories/AssetCategories';
import { AssetHistoryView } from './history/AssetHistoryView';
import { AssetSettingsView } from './settings/AssetSettingsView';
import { AssetReports } from './reports/AssetReports';
import { LicensesView } from './licenses/LicensesView';

export function AssetsHub() {
  return (
    <div className="assets-hub h-full w-full flex-1 flex flex-col min-h-0">
      <Routes>
        {/* Dashboard */}
        <Route index element={<AssetsDashboard />} />

        {/* Asset Management */}
        <Route path="/registry" element={<AssetRegistry />} />
        <Route path="/registry/:registryNumber" element={<ITSMAssetDetailView />} />
        <Route path="/registry/:registryNumber/invoice" element={<ITSMAssetDetailView autoOpenTab="invoice" />} />
        <Route path="/registry/:registryNumber/invocie" element={<ITSMAssetDetailView autoOpenTab="invoice" />} />
        <Route path="/assets/:registryNumber" element={<ITSMAssetDetailView />} />
        <Route path="/assets/:registryNumber/invoice" element={<ITSMAssetDetailView autoOpenTab="invoice" />} />
        <Route path="/assets/:registryNumber/invocie" element={<ITSMAssetDetailView autoOpenTab="invoice" />} />
        <Route path="/assets/:registryNumber/gallery" element={<ITSMAssetDetailView autoOpenTab="gallery" />} />
        <Route path="/assets/:registryNumber/warranty" element={<ITSMAssetDetailView autoOpenTab="warranty" />} />
        <Route path="/:registryNumber" element={<ITSMAssetDetailView />} />
        <Route path="/:registryNumber/invoice" element={<ITSMAssetDetailView autoOpenTab="invoice" />} />
        <Route path="/:registryNumber/invocie" element={<ITSMAssetDetailView autoOpenTab="invoice" />} />
        <Route path="/new" element={<AddAssetView />} />
        <Route path="/add" element={<AddAssetView />} />
        <Route path="/edit/:id" element={<AddAssetView />} />

        {/* Requests & Approvals Workflow (Unified) */}
        <Route path="/requests" element={<AssetRequestsView />} />
        <Route path="/approval" element={<Navigate to="/assets/requests?tab=pending" replace />} />
        <Route path="/requisitions" element={<Navigate to="/assets/requests" replace />} />
        <Route path="/assign" element={<AssetAssignmentView />} />
        <Route path="/return" element={<ReturnAssetView />} />

        {/* Stock & Inventory */}
        <Route path="/stock" element={<StockManagementView />} />

        {/* Lifecycle & Servicing */}
        <Route path="/service" element={<ServiceScheduleView />} />
        <Route path="/warranty" element={<WarrantyTrackerView />} />
        <Route path="/licenses" element={<LicensesView />} />

        {/* Procurement */}
        <Route path="/vendors" element={<AssetVendors />} />
        <Route path="/po" element={<PurchaseOrdersView />} />

        {/* System & Logs */}
        <Route path="/categories" element={<Navigate to="/assets/settings?tab=categories" replace />} />
        <Route path="/history" element={<AssetHistoryView />} />
        <Route path="/settings" element={<AssetSettingsView />} />
        <Route path="/reports" element={<AssetReports />} />
      </Routes>
    </div>
  );
}
